import React from 'react';
import T from "i18n-react/dist/i18n-react";
import { Row, Col, Card, Button } from 'elemental-react16';
import '../../node_modules/elemental-react16/less/elemental.less';

const OrderCompleted = (props) =>{
    return(
        <Card className="order-completed-modal">
            <Row>
                <Col class="order-icon-container" xs="100%" sm="1/3" lg="1/3" style={{textAlign: 'center', position: 'relative', margin: '0px 0px 45px'}}>
                    <div className="order-completed-icon">
                        <i className="far fa-check-circle" />
                    </div>
                </Col>
                <Col xs="100%" sm="2/3" lg="2/3" style={{textAlign: 'center', padding: 0}}>
                    <h1>ORDER COMPLETED</h1>
                    <h4>{T.translate("labels.orderConfirmation1")} <b>{props.userSessionId}</b> {T.translate("labels.orderConfirmation2")}</h4>
                    {
                        props.emailNotific &&
                        <h4>{T.translate("labels.orderConfirmation3")}</h4>
                    }
                    <hr/>
                    <Button type="success" onClick={() => props.handleNewOrder(props.ordersInstance)}>{T.translate("labels.newOrder")}</Button>
                </Col>
            </Row>
        </Card>
    )
};

export default OrderCompleted;


// WEBPACK FOOTER //
// ./src/components/OrderCompleted.js